import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
export const ContainerStyled = styled.div `
  padding: 16px;

  ${ADAPTIVE.minWidth.desktop} {
    max-width: 365px;
  }
`;
export const TitleLabelStyled = styled.div `
  ${({ isDesktop }) => isDesktop && 'width: 165px;'}
  margin-right: ${INDENT.xs};
  overflow-wrap: break-word;
  ${getTextStyles('Ubuntu', 500, 14, 24)};
`;
export const DistanceLabelStyled = styled.div `
  flex: 1;
  text-align: right;
  margin-right: 8px;
`;
